import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Axios  from 'axios';

export default function CommentAdd(props) {
  const [text, setText] = useState("");

  const submitComment = event => {
    Axios.post(
      "api/Community/AddComment",
      {
        CourseNum: props.crsnum,
        Comment: text,
        PostID: props.ID
      },
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    )
      .then(function(response) {
        console.log(response);
        setText('')
          props.commentAdded();
          
      })
      .catch(function(error) {
        console.log(error);
      });
      
    event.preventDefault();
  };
  return (
    <div>
      <div class="user">
        <img src="../assets/img/user/user-13.jpg" />
      </div>
      <div class="input">
        <form action="">
          <div class="input-group">
            <input
              onChange={event => setText(event.target.value)}
              value={text}
              type="text"
              class="form-control rounded-corner"
              placeholder="Write a comment..."
            />
            <span class="input-group-btn p-l-10">
              <button
                class="btn btn-primary f-s-12 rounded-corner"
                type="button"
                onClick={submitComment}
              >
                Comment
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/course/Community/CommentAdd.js